import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from 'projects/services/src/app/API/api.service';
import { RegistrationService } from 'projects/services/src/app/API/registration.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { environment } from 'src/environments/environment';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { TCActorsData } from 'src/app/models/tcActorData';
import { LoginService } from 'projects/services/src/app/API/login/login.service';
declare var toastr: any;
declare var swal: any;
@Component({
	selector: 'app-change-spoc',
	templateUrl: './change-spoc.component.html',
	styleUrls: ['./change-spoc.component.css']
})
export class ChangeSpocComponent implements OnInit {
	show: any;
	@ViewChild('closeModel') closeModel: ElementRef;
	@ViewChild('closeModel1') closeModel1: ElementRef;
	spocDetails: { firstName: string, email: string, mobileNumber: string } = {
		firstName: '',
		email: '',
		mobileNumber: ''
	};
	spocCreationForm: FormGroup;
	verifyCredentialsForm: FormGroup;
	verifyPasswordForm: FormGroup;
	verifyCredDisplay = false;
	verifyCredentialdata: {};
	verifyOtpdata: {};
	tcActorsData: TCActorsData = new TCActorsData();
	userName: string;
	constructor(private formBuilder: FormBuilder,
		private apiService: ApiService,
		private router: Router,
		private location: Location,
		private registrationService: RegistrationService,
		private loginService: LoginService,
		private currentUserService: CurrentUserService) {
		this.spocCreationForm = this.formBuilder.group(
			{
				'firstName': ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z \s]*$'), Validators.maxLength(200)]],
				'email': ['', [Validators.required, ValidationService.emailV]],
				'mobileNumber': ['', Validators.compose([Validators.required,
				Validators.pattern('^[4-9][0-9]{9}$')])],
			});
		this.verifyCredentialsForm = this.formBuilder.group(
			{
				'userName': ['', [Validators.required]],
				'password': ['', [Validators.required]]
			});
		this.verifyPasswordForm = this.formBuilder.group(
			{
				'mobileOTP': ['', [Validators.required, Validators.pattern('[0-9]{6}')]],
				'emailOTP': ['', [Validators.required, Validators.pattern('[0-9]{6}')]]
			});
		this.show = false;
	}

	ngOnInit() {
		// this.currentUserService.setCurrentUser();
		// this.getTcData()
	}

	// getTcData() {
	// 	const loggedInUser = this.currentUserService.decodeToken();
	// 	const getStatusURL = environment.userServiceUrl + '/trainingcentre/' + loggedInUser.userName;
	// 	this.apiService.get(getStatusURL)
	// 		.subscribe(
	// 			res => {
	// 				if (res) {
	// 					this.tcActorsData = Object.assign({}, res[0]);
	// 				}
	// 			},
	// 			err => {
	// 				console.log('error');

	// 			}
	// 		);
	// }
	async generateOtp() {
		// Verifying Cerdential
		const verifyCredentialUrl = environment.userServiceUrl + '/api/user/validate';
		const cred = Object.assign({}, this.verifyCredentialsForm.value);
		const publicKey = await this.loginService.getPublicKey().toPromise();
		console.log(publicKey.publicKey);
		const encrypted = await this.loginService.encryptPassword(publicKey.publicKey, cred.password,publicKey.secret);
		cred.password = encrypted;
		const Credentials: { userName: string, password: string } = cred;
		this.apiService.post(verifyCredentialUrl, Credentials).subscribe(
			res => {
				if (res) {
					// on success of credential generate Otp
					if (res.message === 'Success') {
						const generateOTPUrl = environment.userServiceUrl + '/api/user/reg/v1/generateOTP/TCSpocChange';
						const OTPData: { 'phoneNumber': number, 'email': string } = {
							'phoneNumber': Number(this.spocCreationForm.value.mobileNumber),
							'email': this.spocCreationForm.value.email
						};
						this.registrationService.generateOTPForSPOCChange('TCSpoc', OTPData )
							.subscribe(
								response => {
									this.verifyCredDisplay = true;
								},
								err => {
									toastr.error(err.message);
								});
					} else {
						this.closeModel.nativeElement.click();
					}
				}
			}, err => {
				// toastr.error(err.message);
				// toastr.error('TC username/password incorrect');
			}

		);
	}
	verifyOTP() {
		const createTrainingCentreApi = environment.userServiceUrl + '/api/user/v1/trainingcentre/spoc/change';
		const userAccountData = {
			'mobileOtp': Number(this.verifyPasswordForm.value.mobileOTP),
			'emailOtp': Number(this.verifyPasswordForm.value.emailOTP),
			'firstName': this.spocCreationForm.value.firstName,
			'email': this.spocCreationForm.value.email,
			'mobileNumber': Number(this.spocCreationForm.value.mobileNumber),
			'userName': this.verifyCredentialsForm.value.userName
		};
		this.registrationService.tcSpocChange(userAccountData)
			.subscribe(res => {
				Helpers.closeModal('spoc-popup')
				swal('SPOC details Updated Successfully');
				// this.router.navigate(['/trainingcentre/training-of-trainers']);
				this.back();
			});
	}

	saveSpoc() {
		this.verifyCredDisplay = false;
		this.verifyCredentialsForm.reset();
		this.verifyPasswordForm.reset();
	}

	back() {
		this.location.back();
	}

	showPassClick() {
		this.show = !this.show;
	}

}
